// extracted by mini-css-extract-plugin
export default {"button":"Rj-z","reviewSort":"Sj-z"};